import { Button, DialogActions } from '@mui/material';

type ContractReviseDialogActionsProps = { 
  handleClose: () => void;
  handleSubmit:() => void; 
  text: string;
};

export const ContractReviseDialogActions: React.FC<ContractReviseDialogActionsProps> = ({ handleClose, text, handleSubmit }) => {
  return (
    <DialogActions>
      <Button
        variant="text"
        color="secondary"
        onClick={handleClose}
      >
        Cancel
      </Button>

      <button
        type="submit"
        onClick={handleSubmit}
        className="inline-flex justify-center rounded-md border
                                        border-transparent bg-blue-100 px-4 py-2 text-base font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
      >
        {text}
      </button>
    </DialogActions>
  );
};